import { useSyncExternalStore } from 'react'
import { stoMediaQuery } from 'constants/stoTheme'

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(stoMediaQuery.desktopUp)
  query.addEventListener('change', onChange)
  return () => query.removeEventListener('change', onChange)
}

/** False on the server and during hydration, so the first client render matches the SSR markup. */
export const useIsBelowDesktop = () =>
  useSyncExternalStore(
    subscribe,
    () => !window.matchMedia(stoMediaQuery.desktopUp).matches,
    () => false,
  )
